import { FC, useEffect, useState } from 'react'

import s from './styles.module.scss'

interface Props {
  timeFinished?: string
}

let timerInterval: ReturnType<typeof setTimeout>

function formatTime(minutes: number, seconds: number): string {
  const min = minutes < 10 ? `0${minutes}` : `${minutes}`
  const sec = seconds < 10 ? `0${seconds}` : `${seconds}`
  return `${min}:${sec}`
}

function getRemainingTime(targetTime: Date) {
  const now = new Date()
  const timeDifference = targetTime.getTime() - now.getTime()

  if (timeDifference <= 0) {
    return { minutes: 0, seconds: 0 }
  }

  const totalSeconds = Math.floor(timeDifference / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return { minutes, seconds }
}

export const TimerAppeal: FC<Props> = ({ timeFinished }) => {
  const [timer, setTimer] = useState<string>('')

  useEffect(() => {
    if (timeFinished) {
      onPreparedData(timeFinished)

      timerInterval = setInterval(() => onPreparedData(timeFinished), 1000)
    }

    return () => {
      clearInterval(timerInterval)
    }
  }, [])

  const onPreparedData = (preparedDate: string) => {
    const remainingTime = getRemainingTime(new Date(preparedDate))

    setTimer(`${formatTime(remainingTime.minutes, remainingTime.seconds)}`)

    if (remainingTime.minutes <= 0 && remainingTime.seconds <= 0) {
      clearInterval(timerInterval)
    }
  }

  if (!timeFinished) return null

  return <div className={s.time}>{timer}</div>
}
